import { selectStatisticsState } from "redux/statistics/selectors/selectStatisticsState";
import { createSelector } from "reselect";

export const selectStatisticsCommon = createSelector(
  [selectStatisticsState],
  (statisticsState) => statisticsState.common
);
